import { occFetch } from "~/app/api/occ/occFetch";
import { checkoutAddressUrl } from "./checkoutAddressUrl";

export const editAddress = (activeCartId: string, data: object, id: string): Promise<Response> => {
  return occFetch(checkoutAddressUrl(activeCartId, `/ship/to/address/${encodeURIComponent(id)}`), {
    body: JSON.stringify(data),
    method: "PUT",
    headers: { "Content-Type": "application/json" },
  });
};
